import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AssetDetails from '../components/AssetDetails';
import { ICategory, ICollection, ITemplate } from '../types/damTypes';

interface AssetDetailFullPageProps {
  assetId: string;
  allCategories: ICategory[];
  onAssetDeleted: (assetId: string) => void;
  onClose: () => void;
  onAssetUpdate?: () => void;
  collections?: ICollection[];
  templates?: ITemplate[];
  isAdmin?: boolean;
  canUpdate?: boolean;
  canDelete?: boolean;
  canManageVersions?: boolean;
  canFavorite?: boolean;
  canDownload?: boolean;
  canValidooSync?: boolean;
  canShare?: boolean;
  assetIds?: string[];
  onAssetChange?: (newAssetId: string) => void;
  onOpenAiImageStudioForRecipeAsset?: (assetId: string) => void;
  onOpenAiImageStudioForEditAsset?: (assetId: string) => void;
  onOpenRecipeCorrection?: (assetId: string, options?: { snapshot?: boolean }) => void;
}

const AssetDetailFullPage: React.FC<AssetDetailFullPageProps> = ({
  assetId,
  allCategories,
  onAssetDeleted,
  onClose,
  onAssetUpdate,
  collections,
  templates,
  isAdmin = false,
  canUpdate = false,
  canDelete = false,
  canManageVersions = false,
  canFavorite = false,
  canDownload = false,
  canValidooSync = false,
  canShare = false,
  assetIds = [],
  onAssetChange,
  onOpenAiImageStudioForRecipeAsset,
  onOpenAiImageStudioForEditAsset,
  onOpenRecipeCorrection,
}) => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        overflow: 'auto',
        bgcolor: '#eef2f6',
        px: { xs: 1.5, md: 3 },
        py: { xs: 1.5, md: 2 },
      }}
    >
      <Box
        sx={{
          maxWidth: 1800,
          mx: 'auto',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ mb: 1, flexShrink: 0 }}>
          <Tooltip title="Tillbaka">
            <IconButton
              onClick={onClose}
              aria-label="Tillbaka"
              sx={{
                bgcolor: 'white',
                border: '1px solid',
                borderColor: 'divider',
                '&:hover': { bgcolor: 'grey.100' },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            bgcolor: '#f5f5f5',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            boxShadow: 1,
            overflow: 'hidden',
          }}
        >
          <AssetDetails
            assetId={assetId}
            allCategories={allCategories}
            onAssetDeleted={onAssetDeleted}
            onClose={onClose}
            onAssetUpdate={onAssetUpdate}
            collections={collections}
            templates={templates}
            isAdmin={isAdmin}
            canUpdate={canUpdate}
            canDelete={canDelete}
            canManageVersions={canManageVersions}
            canFavorite={canFavorite}
            canDownload={canDownload}
            canValidooSync={canValidooSync}
            canShare={canShare}
            assetIds={assetIds}
            onAssetChange={onAssetChange}
            layoutVariant="fullPage"
            onOpenAiImageStudioForRecipeAsset={onOpenAiImageStudioForRecipeAsset}
            onOpenAiImageStudioForEditAsset={onOpenAiImageStudioForEditAsset}
            onOpenRecipeCorrection={onOpenRecipeCorrection}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AssetDetailFullPage;
